export const toggleReduxArrayItem = (previousArray, value) => {
  const newArray = previousArray.includes(value)
    ? previousArray.filter((filter) => filter !== value) // Remove if exists
    : [...previousArray, value]; // Add if doesn't exist

  return newArray;
};
